import Layout from "../layouts/layout";
import AddCoupon from "../sections/_coupon/AddCoupon";
import CouponsList from "../sections/_coupon/CouponsList";
import styles from "../styles/_screens/coupon.module.scss";

const Coupon = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <h1>Adding a Coupon Code</h1>
        <AddCoupon />
        <CouponsList />
      </div>
    </Layout>
  );
};

export default Coupon;
